export const normalizeSavedView = (view, products) => {
  const activeIds = new Set(products.map(product => product.id));
  const screenIds = new Set(products.filter(product => product.has_screen).map(product => product.id));
  return {
    ...view,
    selected: activeIds.has(view.selected) ? view.selected : view.selected === 'tm80-fixed' ? 'ge78-fixed' : 'sd-150',
    openings: Object.fromEntries(Object.entries(view.openings || {}).filter(([id]) => activeIds.has(id))),
    screen_extensions: Object.fromEntries(Object.entries(view.screen_extensions || {}).filter(([id]) => screenIds.has(id))),
  };
};